document.addEventListener('DOMContentLoaded', function () {
  const fabricSection = document.querySelector('.fabric-info');
  if (!fabricSection) return;

  const tags = fabricSection.dataset.tags.split(',').map(t => t.trim());

  fabricSection.querySelectorAll('.fabric-image-container, .fabric-content-container')
    .forEach(el => el.style.display = 'none');

  tags.forEach(tag => {
    fabricSection.querySelectorAll('.' + CSS.escape(tag))
      .forEach(el => el.style.display = '');
  });

  const hasMatch = tags.some(tag =>
    fabricSection.querySelector('.' + CSS.escape(tag))
  );
  if (hasMatch) fabricSection.style.display = '';
});